<template>
  <b-button
    variant="action-table-doorder"
    class="view mb-1"
    @click="clickViewOrderRow(order.id)"
    ><img
      src="@/assets/images/doorder/view-icon.png"
      class="view-icon"
      alt="view icon"
  /></b-button>
</template>
<script>
export default {
  name: "ViewOrder",
  props: ["order_id"],
};
</script>


// WEBPACK FOOTER //
// src/components/doorder/orders/datatable_custom_cells/ViewOrder.vue